'use client';

import { ArrowRightIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { Link } from '@/i18n/navigation';
import type { LinkHrefType } from '@/i18n/types';

interface SectionTitleParams {
  className?: string;
  rootClassName?: string;
  children?: React.ReactNode;
  line?: boolean;
  titleEnd?: boolean;
  seeAllHref?: LinkHrefType;
  seeAllLabel?: string;
  titleLevel?: 'h2' | 'h3';
}

const SectionTitle: React.FC<SectionTitleParams> = ({
  children,
  className = '',
  rootClassName = '',
  line = true,
  titleEnd = false,
  seeAllHref,
  seeAllLabel,
  titleLevel = 'h3',
}) => {
  const TitleTag = titleLevel;
  return (
    <div
      className={twMerge(
        'mb-2 flex items-center gap-4 sm:mb-6',
        titleEnd ? 'flex-row-reverse' : '',
        rootClassName,
      )}
    >
      {/* Text */}
      <TitleTag
        className={twMerge(
          'text-base uppercase text-secondary-600 md:text-xl',
          className,
        )}
      >
        {children}
      </TitleTag>
      {/* Vertical line */}
      {line && (
        <div className="flex grow items-center">
          {!titleEnd && <div className="h-8 w-px bg-gray-200" />}
          {/* Horizontal line */}
          <div className="flex-1 border-t border-gray-200" />
          {titleEnd && <div className="h-8 w-px bg-gray-200" />}
        </div>
      )}
      {seeAllHref && seeAllLabel && (
        <Link
          className="animated-underline block text-base leading-tight text-primary-900"
          href={seeAllHref}
        >
          {seeAllLabel} <ArrowRightIcon className="inline size-4 pb-1" />
        </Link>
      )}
    </div>
  );
};

export default SectionTitle;
